// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"32":"dispatcher","43":"test","286":"layout0","393":"layout3","525":"articles","576":"dialogs","592":"common","708":"layout2","748":"layout1","842":"map"}[chunkId] || chunkId) + ".css";
};